module.exports = __webpack_public_path__ + "img/ability-swiper5.dc4ec3ea.png";